import request from '@/utils/request'

const baseUrl = '/erp/customer'

/** 客户分页列表 */
export function pageCustomer (query) {
  return request({
    url: baseUrl + '/page',
    method: 'get',
    params: query
  })
}

/** 客户详情 */
export function getCustomer (id) {
  return request({
    url: baseUrl + '/detail',
    method: 'get',
    params: { id }
  })
}

/** 新建客户 */
export function createCustomer (data) {
  return request({
    url: baseUrl + '/add',
    method: 'post',
    data
  })
}

/** 编辑客户 */
export function updateCustomer (data) {
  return request({
    url: baseUrl + '/edit',
    method: 'post',
    data
  })
}

/** 手机号查重（true=可用） */
export function checkCustomerMobile (params) {
  return request({
    url: baseUrl + '/check-mobile',
    method: 'get',
    params
  })
}

/** 启用客户 */
export function enableCustomer (id) {
  return request({
    url: baseUrl + '/enable',
    method: 'post',
    data: { id }
  })
}

/** 停用客户 */
export function disableCustomer (id) {
  return request({
    url: baseUrl + '/disable',
    method: 'post',
    data: { id }
  })
}

/** 客户类型目录树 */
export function categoryTreeCustomer () {
  return request({
    url: baseUrl + '/category-tree',
    method: 'get'
  })
}
